module.exports = __webpack_public_path__ + "img/the secret god of the sky.869a949c.png";